/* This file is autogenerated, see readme.md for instructions */
import ArrowUpSvgIcon from '@bloomreach/banana-theme/icons/arrow-up.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowUpIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowUpSvgIcon />
    </Icon>
  );
});

ArrowUpIcon.displayName = 'ArrowUpIcon';

export default ArrowUpIcon;
